import { $isPanelOpen } from "@/stores/atoms";
import { cn } from "@/utils/cn";
import { Avatar, Group } from "@mantine/core";
import { useStore } from "@nanostores/react";

interface AccordionLabelProps {
  label: string;
  id: string;
  activePanel: any;
  activeSelections: any;
  color: string;
  maxPanel: any;
  isNumeral?: boolean;
  showSelections?: boolean;
}

export function AccordionLabel({
  label,
  id,
  activePanel,
  maxPanel,
  activeSelections,
  color,
  isNumeral,
  showSelections = true,
}: AccordionLabelProps) {
  const isPanelOpen = useStore($isPanelOpen);

  return (
    <Group p={0} pos="relative" w="100%" wrap="nowrap">
      <Avatar
        className="grid place-items-center"
        color={`${color}.7`}
        radius="md"
        size="sm"
        src=""
        styles={{ placeholder: { borderWidth: "2px" } }}
        style={{ minWidth: 40, minHeight: 40 }}
        variant="filled"
      >
        <p className="text-xl font-bold">{id}</p>
      </Avatar>
      <div className="flex flex-col">
        <p
          className={cn(
            "text-md font-afacad font-bold",
            !showSelections && "text-xl"
          )}
        >
          {label}
        </p>
        {showSelections && (activePanel !== id || !isPanelOpen) && (
          <p className="font-afacad text-[16px] font-normal leading-tight text-[#636363]">
            {activeSelections[id]}
          </p>
        )}
      </div>
    </Group>
  );
}
